import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};
